import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export function PasswordInput({ className = "h-9", testid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input type={show ? "text" : "password"} autoCapitalize="none" autoCorrect="off" spellCheck={false}
        className={`${className} pr-10`} data-testid={testid} {...props} />
      <button type="button" onClick={() => setShow((v) => !v)} tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-slate-400 hover:text-slate-700"
        data-testid={testid ? `${testid}-toggle` : undefined}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
